import React from 'react';

import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { UserAccountBlock } from '../../_blocks/UserAccount';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type UserAccountWidget = WidgetShape<[UserAccountBlock], WidgetType.useraccount>;

export function UserAccountWidget({ blocks, elementType, ...headerProps }: UserAccountWidget) {
  const { t } = useSonTranslation('UserAccount');

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={elementType}
      icon={Icons.USER_PAL}
      hierarchy={3}
      title={t('userAccountFor', { profileName: blocks[0].embedded.profileName })}
    >
      <UserAccountBlock {...blocks[0]} />
    </DefaultWidgetWithHeader>
  );
}
